import reducer from './reducer';
import operations from './operations';
import actions from './actions';

export {
    operations as usersPageOperations,
    actions as usersPageActions
};

export default reducer;
